import * as React from "react";
import { Label } from "components/bootstrap";
import assertUnreachable from "logic/assertUnreachable";
export const STATUS_LABELS = {
  GENERATED: "Generated",
  SUCCESS: "Succeeded",
  DELIVERY_FAILURE: "Delivery failed",
  FAILURE: "Failed",
  RETRYING_DELIVERY: "Retrying delivery",
  RETRYING: "Retrying",
  STARTING: "Starting",
  DELIVERING: "Delivering",
  RUNNING: "Running"
};
const labelForStatus = (status) => {
  if (status in STATUS_LABELS) {
    return STATUS_LABELS[status];
  }
  return assertUnreachable(status, "Report status not handled");
};
const styleForStatus = (status) => {
  switch (status) {
    case "GENERATED":
      return "primary";
    case "SUCCESS":
      return "success";
    case "DELIVERY_FAILURE":
    case "FAILURE":
      return "danger";
    case "RETRYING_DELIVERY":
    case "RETRYING":
      return "warning";
    case "STARTING":
    case "DELIVERING":
    case "RUNNING":
      return "info";
    default:
      return assertUnreachable(status, "Report status not handled");
  }
};
const StatusCell = ({ value }) => {
  const bsStyle = styleForStatus(value);
  return /* @__PURE__ */ React.createElement(Label, { bsStyle }, labelForStatus(value));
};
export default StatusCell;
